import styled from "styled-components";
import { flexbox } from "styled-system";
import { Block } from "components";

export const Flex = styled(Block)`
  ${flexbox};
  display: flex;
`;
